import React from "react";

export default function PageSkeleton() {
  return (
    <div className="min-h-screen bg-biga-cream pt-28 px-5 pb-28" data-testid="page-skeleton" aria-busy="true">
      <div className="max-w-5xl mx-auto space-y-4 animate-pulse">
        <div className="h-9 w-48 rounded-xl bg-biga-ink/10" />
        <div className="h-4 w-72 rounded-lg bg-biga-ink/5" />
        <div className="grid sm:grid-cols-3 gap-4 pt-4">
          {["a", "b", "c"].map((k) => <div key={k} className="h-32 rounded-2xl bg-biga-ink/5" />)}
        </div>
        <div className="h-64 rounded-2xl bg-biga-ink/5" />
      </div>
    </div>
  );
}
